import React from 'react';
import {
  focusEditor,
  indent,
  outdent,
  someNode,
  getPluginType,
  moveListItems,
  usePlateEditorRef,
  useEventPlateId,
  ELEMENT_LI,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ToolbarButton } from './ToolbarButton';

const tooltip = (content) => ({
  content,
});

export const IndentationButtons = ({ ...props }) => {
  const editor = usePlateEditorRef(useEventPlateId());

  return (
    <>
      <ToolbarButton
        name="Outdent"
        tooltip={tooltip('Outdent')}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (isList(editor)) {
            indentOutdentList(editor, false);
          } else {
            outdent(editor, { getNodesOptions: { mode: 'highest' } });
          }

          focusEditor(editor);
        }}
        icon={<FontAwesomeIcon icon={['fa', 'outdent']} />}
        {...props}
      />
      <ToolbarButton
        name="Indent"
        tooltip={tooltip('Indent')}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (isList(editor)) {
            indentOutdentList(editor, true);
          } else {
            indent(editor, { getNodesOptions: { mode: 'highest' } });
          }
          focusEditor(editor);
        }}
        icon={<FontAwesomeIcon icon={['fa', 'indent']} />}
        {...props}
      />
    </>
  );
};

const isList = (editor) => {
  return someNode(editor, { match: { type: getPluginType(editor, ELEMENT_LI) } });
};

const indentOutdentList = (editor, increase) => {
  moveListItems(editor, {
    at: editor.selection,
    increase,
  });
};
